/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

export const GET_WORST_10_LAYERS_RESPONSE = {
	title: "Highest environmental impact - Layers per App",
	barSeries: [
		{
			name: "Environmental Impact",
			bars: [
				{
					name: "GCP Application",
					value: 85,
					unit: "kgCO2"
				},
				{
					name: "AWS German Cluster",
					value: 75,
					unit: "kgCO2"
				},
				{
					name: "Azure Spain Platform",
					value: 65,
					unit: "kgCO2"
				},
				{
					name: "Dummy eCommerce",
					value: 60,
					unit: "kgCO2"
				},
				{
					name: "Fatturazione",
					value: 52,
					unit: "kgCO2"
				},
				{
					name: "APP name max25digt",
					value: 40,
					unit: "kgCO2"
				},
				{
					name: "APP name max25digt",
					value: 35,
					unit: "kgCO2",
					tenantRegion: true
				},
				{
					name: "APP name max25digt",
					value: 30,
					unit: "kgCO2",
					tenantRegion: true
				},
				{
					name: "APP name max25digt",
					value: 25,
					unit: "kgCO2",
					tenantRegion: true
				}
			]
		}
	]
};

export const GET_WORST_10_APPS_RESPONSE = {
	title: "Highest environmental impact - Apps",
	barSeries: [
		{
			name: "Environmental Impact",
			bars: [
				{
					name: "GCP Application",
					value: 85,
					unit: "kgCO2"
				},
				{
					name: "AWS German Cluster",
					value: 75,
					unit: "kgCO2"
				},
				{
					name: "Azure Spain Platform",
					value: 65,
					unit: "kgCO2"
				},
				{
					name: "Dummy eCommerce",
					value: 60,
					unit: "kgCO2"
				},
				{
					name: "Fatturazione",
					value: 52,
					unit: "kgCO2"
				},
				{
					name: "APP name max25digt",
					value: 40,
					unit: "kgCO2"
				},
				{
					name: "APP name max25digt",
					value: 35,
					unit: "kgCO2",
					tenantRegion: true
				},
				{
					name: "APP name max25digt",
					value: 30,
					unit: "kgCO2",
					tenantRegion: true
				},
				{
					name: "APP name max25digt",
					value: 25,
					unit: "kgCO2",
					tenantRegion: true
				}
			]
		}
	]
};
